import React from "react";

interface VBars {
    size?: 'small' | 'medium' | 'large';
    className?: string;
}

function VBars(props: Readonly<VBars>) {
    let sizes = {
        small: { width: 21, height: 20 },
        medium: { width: 57, height: 56 },
        large: { width: 76, height: 75 }
    }
    let _size: 'small' | 'medium' | 'large' = 'medium';
    if (props.size) {
        _size = props.size
    }
    return (
        <>
            <svg className={props.className} width={sizes[_size].width} height={sizes[_size].height} viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0px auto'}}>
                <defs>
                    <linearGradient id="verticalGradient" x1="0%" y1="0%" x2="0%" y2="100%" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stop-color="#4B75C3"/>
                        <stop offset="50%" stop-color="#00A6A4"/>
                        <stop offset="100%" stop-color="#2BE4DB"/>
                    </linearGradient>
                </defs>
                <rect x="1" y="0" width="5" height="56" rx="2" fill="url(#verticalGradient)">
                    <animate attributeName="height" begin="0s" dur="1s" values="30;56;30" repeatCount="indefinite" />
                    <animate attributeName="y" begin="0s" dur="1s" values="15;0;15" repeatCount="indefinite" />
                </rect>
                <rect x="11" y="5" width="5" height="46" rx="2" fill="url(#verticalGradient)">
                    <animate attributeName="height" begin="0.2s" dur="1s" values="30;56;30" repeatCount="indefinite" />
                    <animate attributeName="y" begin="0.2s" dur="1s" values="15;0;15" repeatCount="indefinite" />
                </rect>
                <rect x="21" y="10" width="5" height="36" rx="2" fill="url(#verticalGradient)">
                    <animate attributeName="height" begin="0.4s" dur="1s" values="30;56;30" repeatCount="indefinite" />
                    <animate attributeName="y" begin="0.4s" dur="1s" values="15;0;15" repeatCount="indefinite" />
                </rect>
                <rect x="31" y="10" width="5" height="36" rx="2" fill="url(#verticalGradient)">
                    <animate attributeName="height" begin="0.6s" dur="1s" values="30;56;30" repeatCount="indefinite" />
                    <animate attributeName="y" begin="0.6s" dur="1s" values="15;0;15" repeatCount="indefinite" />
                </rect>
                <rect x="41" y="5" width="5" height="46" rx="2" fill="url(#verticalGradient)">
                    <animate attributeName="height" begin="0.8s" dur="1s" values="30;56;30" repeatCount="indefinite" />
                    <animate attributeName="y" begin="0.8s" dur="1s" values="15;0;15" repeatCount="indefinite" />
                </rect>
                <rect x="51" y="0" width="5" height="56" rx="2" fill="url(#verticalGradient)">
                    <animate attributeName="height" begin="1s" dur="1s" values="30;56;30" repeatCount="indefinite" />
                    <animate attributeName="y" begin="1s" dur="1s" values="15;0;15" repeatCount="indefinite" />
                </rect>
            </svg>
        </>
    )
}

export default VBars;